import { render, staticRenderFns } from "./BandeiraJcb.vue?vue&type=template&id=23058f5d&"
import script from "./BandeiraJcb.vue?vue&type=script&lang=js&"
export * from "./BandeiraJcb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports